import { render, staticRenderFns } from "./ActiveOrders.vue?vue&type=template&id=4d054118&"
import script from "./ActiveOrders.vue?vue&type=script&lang=js&"
export * from "./ActiveOrders.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrders.vue?vue&type=style&index=0&id=4d054118&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports